import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/contact`, formData);
      toast.success("Message envoyé !");
      setFormData({ name: '', email: '', message: '' });
    } catch (e) {
      toast.error("Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-24 pb-20 px-4 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-12 text-center">Contactez-nous</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
           <div className="space-y-8">
              <div className="bg-neutral-900/50 p-8 rounded-2xl border border-white/10">
                 <h3 className="text-2xl font-bold mb-6">Informations</h3>
                 <div className="space-y-6">
                    <div className="flex items-center gap-4 text-gray-300">
                       <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center text-purple-400">
                          <Mail />
                       </div>
                       <div>
                          <div className="font-bold">Email</div>
                          <div>asso.jeanjo.unis@gmail.com</div>
                       </div>
                    </div>
                    
                    <div className="flex items-center gap-4 text-gray-300">
                       <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center text-blue-400">
                          <Phone />
                       </div>
                       <div>
                          <div className="font-bold">Téléphone</div>
                          <div>+33 6 63 15 61 44</div>
                       </div>
                    </div>

                    <div className="flex items-center gap-4 text-gray-300">
                       <div className="w-12 h-12 bg-pink-500/20 rounded-xl flex items-center justify-center text-pink-400">
                          <MapPin />
                       </div>
                       <div>
                          <div className="font-bold">Studio</div>
                          <div>18 avenue des arnavaux, Marseille</div>
                       </div>
                    </div>
                 </div>
              </div>
           </div>

           <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                 <label className="block text-sm font-bold mb-2">Nom</label>
                 <input 
                    type="text" 
                    required
                    className="w-full bg-neutral-900 border border-white/10 rounded-xl p-4 focus:outline-none focus:border-purple-500 transition-colors"
                    value={formData.name}
                    onChange={e => setFormData({...formData, name: e.target.value})}
                 />
              </div>
              <div>
                 <label className="block text-sm font-bold mb-2">Email</label>
                 <input 
                    type="email" 
                    required
                    className="w-full bg-neutral-900 border border-white/10 rounded-xl p-4 focus:outline-none focus:border-purple-500 transition-colors"
                    value={formData.email}
                    onChange={e => setFormData({...formData, email: e.target.value})}
                 />
              </div>
              <div>
                 <label className="block text-sm font-bold mb-2">Message</label>
                 <textarea 
                    required
                    rows="5"
                    className="w-full bg-neutral-900 border border-white/10 rounded-xl p-4 focus:outline-none focus:border-purple-500 transition-colors resize-none"
                    value={formData.message}
                    onChange={e => setFormData({...formData, message: e.target.value})}
                 />
              </div>
              <button 
                 type="submit" 
                 disabled={loading}
                 className="w-full py-4 bg-white text-black font-bold rounded-xl hover:bg-gray-200 transition-all flex items-center justify-center gap-2"
              >
                 {loading ? 'Envoi...' : <><Send className="w-4 h-4" /> Envoyer</>}
              </button>
           </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
